import * as L from 'leaflet';
import { ButtonDivIcon } from './button-div-icon';
import { TranslationService } from '../../../../services/translation.service';
import darkScooterIcon from '../../../../../assets/icons/micromobility-scooter-dark.svg';
import darkBikeElectricAssistIcon from '../../../../../assets/icons/micromobility-bike-electric-assist-dark.svg';
import DataUrlHelper from '../../../../helpers/data-url.helper';
import { FormFactor } from '../../../../models/labs/micromobility/form-factor.enum';
import { PropulsionType } from '../../../../models/labs/micromobility/propulsion-type.enum';

export default class DocklessVehicleClusterDivIcon extends ButtonDivIcon {
  constructor(cluster: L.MarkerCluster, formFactor: FormFactor, propulsionType: PropulsionType) {
    super(
      {
        className: 'vehicle-cluster-div-icon micromobility-marker d-flex flex-row align-items-center justify-content-center bg-white border border-blue-1000 text-color-blue-1000',
        html: `<img src="${DataUrlHelper.encode(
          formFactor === FormFactor.Bicycle && propulsionType === PropulsionType.ElectricAssist ? darkBikeElectricAssistIcon : darkScooterIcon
        )}" alt="" class="vehicle-cluster-div-icon__icon me-1" /><span>${cluster.getChildCount()}</span>`,
      },
      `${TranslationService.get('labs.micromobility.micromobilitysearchpage.clusterwith')} ${cluster.getChildCount()} ${TranslationService.get(
        'labs.micromobility.micromobilitysearchpage.formfactor.scooter.plural'
      ).toLocaleLowerCase()}`
    );
  }
}
